function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8.00004 1.33334C4.29634 1.33334 1.33337 4.29631 1.33337 8.00001C1.33337 11.7037 4.29634 14.6667 8.00004 14.6667C8.59263 14.6667 9.11115 14.1482 9.11115 13.5556C9.11115 13.2593 9.03708 13.037 8.81486 12.8148C8.66671 12.5926 8.51856 12.3704 8.51856 12.0741C8.51856 11.4815 9.03708 10.963 9.62967 10.963H10.963C13.0371 10.963 14.6667 9.33334 14.6667 7.25927C14.6667 4.00001 11.7037 1.33334 8.00004 1.33334Z",
  strokeWidth: 2
});

var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 4.33337,
  cy: 8.33334,
  rx: 1,
  ry: 1,
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 6.33337,
  cy: 5,
  r: 1,
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 10.3334,
  cy: 5,
  r: 1,
  fill: "currentColor"
});

function SvgOptions(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    className: "feather",
    ref: svgRef
  }, props), _ref, _ref2, _ref3, _ref4);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptions);
export default __webpack_public_path__ + "static/media/options.b4df8d71.svg";
export { ForwardRef as ReactComponent };